import { Component, OnDestroy, OnInit } from '@angular/core';
import { DQOIItem } from '@app/cp/shared/models/DQOIItem';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { Router } from '@angular/router';
import { DQOISearchEvent } from '@app/cp/shared/models/DQOISearchEvent';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import * as _ from 'lodash';
import { DQOIMessage } from '@app/cp/shared/models/DQOIMessage';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { DispatchBus } from '@app/cp/shared/models/DispatchBus';
import { Subscription,concatMap} from 'rxjs';
import { BaseMessageInfo } from '../shared/models/BaseMessageInfo';
import { DQOIReferenceData } from '../shared/models/DQOIReferenceData';
import { CommonValues } from '../shared/static/CommonValues';
import { DQOIDisplaySettings } from '../shared/models/DQOIDisplaySettings';
import { DispatchData } from '../shared/models/DispatchData';

@Component({
    selector: 'cp-quick-view',
    templateUrl: './quick-view.component.html',
    styleUrls: ['./quick-view.component.scss']
})
export class QuickViewComponent implements OnDestroy, OnInit {

    constructor(private globals: GlobalsService, svc_dqoi: DQOIService, private svc_dispatch: DispatchesService, private qry_rd: DQOIReferenceDataQuery, private router: Router) {

        this.svc_dqoi = svc_dqoi;
        this.url = this.router.url;
    }

    private showContractError(error?: string) {
        const errMsg = error ? "Error: " + error + " ": " ";
        this.globals.notifyError(`Unable to load contract.${errMsg}${CommonValues.ErrorMessages_BaseErrorSuffix}`, true);
        this.loaderState = false;
    }
    ngOnInit(): void {
        this.refDataSub = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).pipe(
            concatMap(() => this.qry_rd.referenceDataUpdated)
                ).subscribe({
                    next: (refData: DQOIReferenceData) => {
                        if (!refData) {
                            return;
                        }
                        if (this.url && !this.hasBeenLoaded) {
                            this.setContractFromRoute(this.url);
                        }
                    },
                    error: err => {
                        console.error(err);
                        this.showContractError();
                    }
                });
    }
    iscboi: boolean = false;
    isdqoi: boolean = false;
    url: string;
    svc_dqoi: DQOIService;

    dqoiItems: DQOIItem[] = [];
    event: DQOISearchEvent = new DQOISearchEvent();
    searchTarget: SearchTarget = SearchTarget.contract;
    refDataSub: Subscription;
    hasBeenLoaded: boolean = false;
    loaderState: boolean = true;

    dispatchData: DispatchData = null;


    trackByFunction(index: number, item: DQOIItem) {
        if (!item) return null;
        return item.index;
    }

    onDQOIMessage(e: DQOIMessage) {
        this.loaderState = false;
        if (e.messageType === MessageType.close && CommonFunctions.hasValue(e.messageData)) {
            let index: number = e.messageData;
            let arr: DQOIItem[] = [];
            for (let i = 0; i < this.dqoiItems.length; i++) {
                if (index !== this.dqoiItems[i].index) {
                    arr.push(this.dqoiItems[i]);
                }
            }
            this.dqoiItems = arr;

        }
        else if (e.messageType === MessageType.searchChanged) {
        }
    }

    setContractFromRoute(url: string) {
        this.hasBeenLoaded = true;
        if (url.toLowerCase().indexOf("quickview") >= 0 || url.toLowerCase().indexOf("popout") >= 0) {
            let urlParts = url.split("/");
            this.event.clear();
            let busType: string = urlParts[urlParts.length - 3];
            if (busType.toLowerCase() === "construction") {
                this.iscboi = true;
                this.isdqoi = false;
            }
            else {
                this.iscboi = false;
                this.isdqoi = true;
            }
            //Begin: The below conditional assumes that if the url is "popout" then we are looking at a CP Dispatch being viewed by a zuggit user.
            //This may have to change in the future if we want to support other popout scenarios.
            //And we will need to figure out a better way of passing in DispatchData with DQOIDisplaySettings.
            if (url.toLowerCase().indexOf("popout") >= 0) {
                this.dispatchData = new DispatchData();
                let dqoiDisplaySettings = new DQOIDisplaySettings({ useCPRefData: true, forceReadOnly: false });
                this.dispatchData.dqoiDisplaySettings = dqoiDisplaySettings;
            }
            //End

            let targetType: SearchTarget = parseInt(urlParts[urlParts.length - 2]);
            this.event.searchTarget = targetType;
            this.event.id = urlParts[urlParts.length - 1];
            if (this.event.searchTarget === SearchTarget.dispatch) {
                this.event.dispatchId = this.event.id;
            }
            else if (this.event.searchTarget === SearchTarget.contract) {
                this.event.dispatchId = this.event.id;
            }
            else if (this.event.searchTarget === SearchTarget.job) {
                this.event.dispatchId = this.event.id;
            }
            this.setTitle();
            this.searchSel(this.event);
        }
    }

    setTitle() {
        if (this.event.searchTarget === SearchTarget.dispatch) {
            this.svc_dispatch.get(this.event.id).subscribe((data: DispatchBus) => {
                this.globals.setTitle('QV - ' + data.dispatchNumber);
            });
        }
    }

    ngOnDestroy() {
        this.globals.setTitle('');
        CommonFunctions.unsubscribe(this.refDataSub);
    }

    searchSel(data: DQOISearchEvent) {
        let se: DQOISearchEvent = new DQOISearchEvent(data);
        let item: DQOIItem = null;
        let idTarget = se.searchTarget + ":" + se.id;
        if (se.hasId) {
            this.svc_dqoi.getDQOITemConstFromDb(idTarget).subscribe(
                {
                    next: (info: BaseMessageInfo) => {
                        if (!info.saveError) {
                            item = new DQOIItem(info.primaryReturn);
                            item.searchTarget = data.searchTarget;
                            if (item.isConstruction == true) {
                                if (CommonFunctions.hasGuidValue(item.masterJobId)) {
                                    if (item.masterJobId !== item.dispatchId) {
                                        item.dispatchId = item.masterJobId;
                                        item.dispatchNumber = item.contractNumber;
                                    }
                                }
                            }
                            this.setItemId(item, data);
                            if (CommonFunctions.hasValue(item.id) || CommonFunctions.hasValue(item.number)) {
                                this.addDQOIItem(item);
                            }
                        } else {
                            this.showContractError(info.message);
                            console.error(info.message);
                        }
                    },
                    error: err => {
                        this.showContractError();
                        console.error(err);
                    }
            });
        }
        else {
            item = new DQOIItem();
            item.searchTarget = data.searchTarget;
            if (item === null && data !== null) {
                switch (data.searchTarget) {
                    case SearchTarget.contract:
                        item.id = data.dispatchId;
                        item.dispatchId = item.id;
                        break;
                    case SearchTarget.job:
                        item.id = data.dispatchId;
                        item.dispatchId = item.id;
                        break;
                    case SearchTarget.invoice:
                        item.number = data.invoiceNumber;
                        break;
                    case SearchTarget.quote:
                        item.number = data.quoteNumber;
                        break;
                    case SearchTarget.order:
                        item.number = data.orderNumber;
                        break;
                }
            }
            if (CommonFunctions.hasValue(item.id) || CommonFunctions.hasValue(item.number)) {
                this.addDQOIItem(item);
            }
        }
    }

    private setItemId(item: DQOIItem, data: DQOISearchEvent) {
        switch (item.searchTarget) {
            case SearchTarget.contract:
                item.id = item.contractId;
                break;
            case SearchTarget.job:
                item.id = data.dispatchId;
                break;
            case SearchTarget.dispatch:
                item.id = data.dispatchId;
                break;
            case SearchTarget.invoice:
                item.number = data.invoiceNumber;
                item.id = data.id;
                break;
            case SearchTarget.quote:
                item.number = data.quoteNumber;
                item.id = data.id;
                break;
            case SearchTarget.order:
                item.number = data.orderNumber;
                item.id = data.id;
                break;
        }
    }

    addDQOIItem(data: DQOIItem) {
        this.loaderState = false;

        let index: number = 1;
        if (CommonFunctions.hasArrayValue(this.dqoiItems)) {
            index = Math.max(...this.dqoiItems.map(x => x.index), 0) + 1;
        }
        data.index = index;
        data.isConstruction = true;

        this.svc_dqoi.setDQOIItem(data);
        this.dqoiItems = _.concat(data, this.dqoiItems);
    }
}
